export default {
  title: 'Aktualizacja czasu!',
  labels: {
    old_time: 'Poprzedni czas odbioru:',
    new_time: 'Nowy czas odbioru:',
  },
  buttons: {
    print: 'Drukuj i zamknij',
    got_it: 'Rozumiem',
  },
  feedback: {
    new_prep_time: 'Czas dostawy został zaktualizowany. Dostosuj harmonogram przygotowania.',
  },
  toasts: {
    something_went_wrong: 'Coś poszło nie tak, spróbuj ponownie',
  },
};
